import { render, staticRenderFns } from "./Sim-mobile.vue?vue&type=template&id=ae96b64e&scoped=true"
import script from "./Sim-mobile.vue?vue&type=script&lang=js"
export * from "./Sim-mobile.vue?vue&type=script&lang=js"
import style0 from "./Sim-mobile.vue?vue&type=style&index=0&id=ae96b64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae96b64e",
  null
  
)

export default component.exports